let MapDataAdapterFactory = function() {
  this.dataAdDapter = ''
}

MapDataAdapterFactory.prototype = {
  make: function(mapType) {
    if (mapType == 'google') {
      return new Google()
    } else if (mapType == 'leaflet') {
      return new Leaflet()
    } else {
      throw new Error(`Unsupported mapType: ${mapType}`)
    }
  }
}

let Google = function() {
  this.adapt = function(mapData) {
    if (mapData.eventType == 'CIRCLE') {
      let radius = 0
      let coordinates = {}
      if(mapData.circle.hasOwnProperty('_mRadius')) {
        radius = mapData.circle._mRadius
        coordinates = {
          lat: mapData.circle._latlng.lat,
          lng: mapData.circle._latlng.lng
        }
      }

      if(mapData.circle.hasOwnProperty('radius')) {
        radius = mapData.circle.radius
        coordinates = {
            lat: mapData.circle.center.lat(),
            lng: mapData.circle.center.lng()
          }
      }
      return {
        coordinates,
        radius
      }
    }

    if (mapData.eventType == 'POLYGON') {
      // MVCArray of LatLngs
      let vertices = mapData.polygon.getPath()
      let coordinates = []

      for (let i = 0; i < vertices.getLength(); i++) {
        let xy = vertices.getAt(i)

        coordinates.push({
          lat: xy.lat(),
          lng: xy.lng()
        })
      }

      return {
        coordinates: coordinates,
        radius: ''
      }
    }
  }
}

let Leaflet = function() {
  this.adapt = function(mapData) {
    if (mapData.eventType == 'CIRCLE') {
      let radius = mapData.circle._mRadius
      let coordinates = {
        lng: mapData.circle._latlng.lng,
        lat: mapData.circle._latlng.lat
      }

      return {
        coordinates,
        radius
      }
    }

    if (mapData.eventType == 'POLYGON') {
      let coordinates = []

      for (let i = 0; i < mapData.polygon._latlngs[0].length; i++) {
        coordinates.push({
          lat: mapData.polygon._latlngs[0][i].lat,
          lng: mapData.polygon._latlngs[0][i].lng
        })
      }

      return {
        coordinates: coordinates,
        radius: ''
      }
    }
  }
}

export { MapDataAdapterFactory }
